export default __webpack_public_path__ + "static/media/itop_logo.ea515338.png";